import { faFolderBlank, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useDrop } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import Loading from '../../../../../components/Loaders/Loading';
import { ItemTypes } from '../../constants';
import FolderTreeItem from './FolderTreeItem';

const ParentDropTarget = ({ isActive, onNavigate }) => {
  const { t } = useTranslation();

  const [{ isOver }, drop] = useDrop({
    accept: [ItemTypes.REPORT, ItemTypes.FOLDER],
    drop: () => ({ folderId: null }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return (
    <button
      type="button"
      ref={drop}
      className={`menu__parent-folder ${isActive ? 'menu__parent-folder--active' : ''} ${isOver ? 'menu__parent-folder--hovered' : ''}`}
      onClick={onNavigate}
      title={t('reports-parent')}
    >
      <FontAwesomeIcon icon={faFolderBlank} className="menu__parent-folder-icon" />
      <span>{t('reports-parent')}</span>
    </button>
  );
};

const ReportDesktopMenu = ({
  getItemsByParentId,
  itemsCache,
  itemsTotals,
  onNavigate,
  openContextMenu,
  openCreateFolderModal,
  loading,
  activeFolderId,
  folderPath
}) => {
  const rootItems = (itemsCache['root'] || []).filter(item => item.type === 'folder');
  const activeFolderIds = folderPath.map(folder => folder.id).filter(id => id);

  useEffect(() => {
    if (!itemsCache['root']) {
      const controller = new AbortController();
      getItemsByParentId(null, controller, 1, undefined, false);
      return () => controller.abort();
    }
  }, [getItemsByParentId, itemsCache]);

  return (
    <div className="menu">
      <div className="menu__header">
        <ParentDropTarget
          isActive={!activeFolderId}
          onNavigate={() => onNavigate({ type: 'folder', id: null })}
        />
        <FontAwesomeIcon
          icon={faPlus}
          onClick={openCreateFolderModal}
          className="menu__add-folder-icon"
        />
      </div>
      {loading ? (
        <Loading />
      ) : (
        <ul className="menu__list">
          {rootItems.map((item) => (
            <FolderTreeItem
              key={item.id}
              item={item}
              getItemsByParentId={getItemsByParentId}
              itemsCache={itemsCache}
              itemsTotals={itemsTotals}
              onNavigate={onNavigate}
              openContextMenu={openContextMenu}
              activeFolderId={activeFolderId}
              activeFolderIds={activeFolderIds}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default ReportDesktopMenu;
